import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import {
  RequestDeleteAccountsDto, RequestGetPolicyDto,
  ResponseDeleteAccountsDto,
  ResponseGetListEmpRehireDto, ResponseGetPolicyDto, RequestGetEmpDto, ResponsetGetEmpDto, RequestSavePictureDto,
} from "../dto/sf-profile.dto";
import { ResponseData } from '../../nest-responses';

@Injectable()
export class SfProfileApi {

  private service: string = '';
  private model: string = 'sfprofile';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public deleteAccounts(payload: RequestDeleteAccountsDto): Observable<ResponseDeleteAccountsDto> {
    const method: string = 'POST';
    const func: string = 'deleteAccounts';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteAccountsDto>(method, url, params, urlParams, body);
  }

  public getListEmpRehire(limit: string | number, page: string | number, q: string): Observable<ResponseGetListEmpRehireDto> {
    const method: string = 'GET';
    const func: string = 'getListEmpRehire';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof q !== 'undefined' && q !== null) urlParams.q = q;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetListEmpRehireDto>(method, url, func, params, body);
  }

  getPolicy(data: RequestGetPolicyDto): Observable<ResponseGetPolicyDto> {
    const method: string = 'POST';
    const func: string = 'getPolicy';
    const params: RequestGetPolicyDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetPolicyDto>(method, url, params, urlParams, body);
  }

  getEmp(payload: RequestGetEmpDto): Observable<ResponseData<ResponsetGetEmpDto>> {
    const method: string = 'POST';
    const func: string = 'getEmp';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponsetGetEmpDto>>(method, url, params, urlParams, body);
  }

  saveFotoProfile(payload: RequestSavePictureDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'saveFotoProfile';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  getSocial(empId: string): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'getSocial';
    const params: any = { empId: empId };
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  getTimezone(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getTimezone';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-profile.api.ts